import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			// light: will be calculated from palette.primary.main,
			main: "#9575cd",
			dark: "#78649c",
		},
		secondary: {
			main: "#aed581",
		},
		// Provide every color token (light, main, dark, and contrastText) when using
		// custom colors for props in Material UI's components.
		// Then you will be able to use it like this: `<Button color="custom">`
		// (For TypeScript, you need to add module augmentation for the `custom` value)
		custom: {
			light: "#ffa726",
			main: "#f57c00",
			dark: "#ef6c00",
			contrastText: "rgba(0, 0, 0, 0.87)",
		},
		// Used by `getContrastText()` to maximize the contrast between
		// the background and the text.
		contrastThreshold: 3,
		// Used by the functions below to shift a color's luminance by approximately
		// two indexes within its tonal palette.
		// E.g., shift from Red 500 to Red 300 or Red 700.
		tonalOffset: 0.2,
	},
	typography: {
		// In Chinese and Japanese the characters are usually larger,
		// so a smaller fontsize may be appropriate.
		//fontSize: "1.45rem",
		caption: {
			//fontSize: "1.2rem",
		},
		overline: {
			//fontSize: "1.2rem",
		},
		button: {
			//fontSize: "1.35rem",
		},
		projectTag: {
			fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
			fontWeight: 400,
			fontSize: ".7rem",
			lineHeight: 1.66,
			letterSpacing: "0.03333em",
			textTransform: "uppercase",
			opacity: 0.7,
		},
		projectTitle: {
			fontFamily: '"Lilita One", "Roboto", "Helvetica", "Arial", sans-serif',
			fontWeight: 400,
			//fontSize: "1.875rem",
			lineHeight: 1.75,
			letterSpacing: "0.02857em",
			textTransform: "uppercase",
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: ({ ownerState }) => ({
					"&:hover": {
						color: "#5f468a",
					},
				}),
			},
		},
		MuiFab: {
			styleOverrides: {
				root: {
					"&:hover": {
						color: "#fff",
					},
				},
			},
		},
	},
});

export default theme;
